import Column from '@components/Column';
import Text from '@components/Text';
import TextField from '@components/TextField';
import colors from '@constants/colors';
import useUser from '@hooks/auth/useUser';
import GiftOrderContext from '@providers/GiftOrderProvider/GiftOrderContext';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';

function Sender() {
    const { handleChange, state } = useContext(GiftOrderContext);
    const { t } = useTranslation('gift');
    const { user } = useUser();

    return (
        <Column fullWidth spacing={1}>
            <Text color={colors.textSecondary} fontWeight='medium' size='body-short'>
                {t('giftOrder.senderTitle')}
            </Text>
            <TextField
                placeholder={t('giftOrder.senderNamePlaceholder')}
                clearable
                onChange={handleChange}
                name='userName'
                value={state.userName}
            />
            {user && !state.userPhone && (
                <Text role='alert' size='body-long' color={colors.red}>
                    {t('giftOrder.phoneMissing')}
                </Text>
            )}
        </Column>
    );
}

export default Sender;
